<div class="card">
  <app-header titulo="Provisão" descricao="Dados de Provisão"></app-header>
  <p-toast />
  <p-table [value]="provisoes77p" dataKey="id" [loading]="loading" #dt [globalFilterFields]="['empresaErp','ordem','tipoPropriedade','contaCredito','contaDebito','centroCusto']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <a [routerLink]="['novo']"><button icon="pi pi-plus" label="Novo Cadastro" pButton></button></a>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Empresa Erp</th>
            <th>Ordem</th>
            <th>Tipo Propriedade</th>
            <th>Conta Credito</th>
            <th>Conta Débito</th>
            <th>Centro de Custo</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-provisao77p>
        <tr>
            <td>{{ provisao77p.empresaErp }}</td>
            <td>{{ provisao77p.ordem }}</td>
            <td>{{ provisao77p.tipoPropriedade }}</td>
            <td>{{ provisao77p.contaCredito }}</td>
            <td>{{ provisao77p.contaDebito }}</td>
            <td>{{ provisao77p.centroCusto }}</td>
            <td>
              <a [routerLink]="['editar', provisao77p.id]">
                <p-button icon="pi pi-pencil"
                          severity="primary"
                          class="m-2"
                          [rounded]="true"
                          [outlined]="true" >
                </p-button>
              </a>

              <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [rounded]="true"
                        [outlined]="true"
                        (onClick)="confirmarExclusao(provisao77p.id)" />
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
